module.exports = __webpack_public_path__ + "img/open_easy.png";